import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import RestaurantListRow, { RestaurantListCard } from "./RestaurantListRow";
import useLoginCheck from "../util/useLoginCheck";
import Spinner from "../util/Spinner";
import { fetchRestaurantLists } from "../slice/restaurantListsSlice";

const RestaurantLists = () => {
  const dispatch = useDispatch();
  const { restaurantLists, isLoading } = useSelector(
    (state) => state.restaurantLists
  );
  const [shouldRefresh, setShouldRefresh] = useState(true);

  const navigate = useNavigate();

  useLoginCheck();

  useEffect(() => {
    dispatch(fetchRestaurantLists());
  }, [dispatch, shouldRefresh]);

  return (
    <div className="max-w-3xl mx-auto p-4">
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <div className="flex justify-end mb-4">
            <button
              className="btn-primary"
              onClick={() => navigate("/restaurants/new")}
            >
              New
            </button>
          </div>
          {restaurantLists && restaurantLists.lists && restaurantLists.lists.length > 0 ? (
            <div>
              <table className="hidden md:table w-full card">
                <thead>
                  <tr className="text-left text-sm text-stone-500 border-b border-stone-200">
                    <th className="px-3 py-2 font-medium">Name</th>
                    <th className="px-3 py-2 font-medium">Type</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-stone-200">
                  {restaurantLists.lists.map((restaurantList) => (
                    <RestaurantListRow
                      key={restaurantList.sid}
                      restaurantList={restaurantList}
                    />
                  ))}
                </tbody>
              </table>
              <ul className="md:hidden space-y-3">
                {restaurantLists.lists.map((restaurantList) => (
                  <RestaurantListCard
                    key={restaurantList.sid}
                    restaurantList={restaurantList}
                  />
                ))}
              </ul>
            </div>
          ) : (
            <p className="text-stone-500">No restaurant lists entered</p>
          )}
        </>
      )}
    </div>
  );
};

export default RestaurantLists;
